<template>

   <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
       <v-card>
           <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
               <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
               <v-toolbar-title>Nova NFS-e</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-toolbar-items>
                   <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
               </v-toolbar-items>
           </v-toolbar>

           <v-card-text class="mt-5">
               <v-form id="formCadastroNFSe" ref="formCadastroNFSe" v-model="valid" lazy-validation >
                   <v-row>
                       <v-col cols="12" md="2" sm="3">
                           <v-text-field type="number" v-model="item.numero" label="Número" dense outlined disabled/>
                       </v-col>
                       <v-col cols="12" md="2" sm="3">
                           <v-text-field type="number" v-model="item.serieRps" label="Série RPS" dense outlined/>
                       </v-col>
                       <v-col cols="12" md="2" sm="3">
                           <v-text-field type="number" v-model="item.numeroRps" label="Número RPS" dense outlined/>
                       </v-col>
                       <v-col cols="12" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataEmissao" label="Emissão" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataEmissao" no-title/>
                            </v-menu>
                        </v-col>
                   </v-row>
                   <v-row>
                        <v-col cols="12" md="12">
                          <v-autocomplete v-model="item.doadorId" :items="doadores" :loading="isDoadorLoading" :search-input.sync="searchDoador" hide-no-data hide-selected cache-items clearable
                              item-text="cpfCnpjNome" item-value="id" label="Doador" :placeholder="item.doador ? item.doador.cpfCnpjNome : 'Digite um doador'" :disabled="item.id > 0" dense outlined/>
                        </v-col>
                    </v-row>
                   <v-row>
                       <v-col cols="12" md="12" sm="12">
                           <v-textarea v-model="item.discriminacao" label="Discriminação" :counter="1000" maxlength="1000" dense outlined/>
                       </v-col>
                   </v-row>
                   <v-row>
                       <v-col cols="12" md="2" sm="2">
                           <v-text-field type="number" v-model="item.valor" label="Valor" dense outlined/>
                       </v-col>
                       <v-col cols="12" md="2" sm="2">
                           <v-text-field type="number" v-model="item.aliquotaIss" label="(%) ISS" dense outlined/>
                       </v-col>
                       <v-col cols="12" md="2" sm="2">
                           <v-text-field type="number" v-model="item.valorIss" label="Valor ISS" dense outlined disabled/>
                       </v-col>
                       <v-col cols="12" md="2" sm="2">
                           <v-switch style="margin-top: 5px" v-model="item.retido" label="Reter" dense/>
                       </v-col>
                       <v-col cols="12" md="2" sm="2">
                           <v-text-field type="number" v-model="item.valorRetido" label="Valor Retido" dense outlined disabled/>
                       </v-col>
                       <v-col cols="12" md="2" sm="2">
                           <v-text-field type="number" v-model="item.valorLiquido" label="Valor Líquido" dense outlined disabled/>
                       </v-col>
                   </v-row>
                   <v-row v-if="item.nfseAutorizacao && (item.nfseAutorizacao.dataHora || item.nfseAutorizacao.chaveAcesso || item.nfseAutorizacao.urlVisualizacao)">
                       <v-col cols="12" md="4" sm="6">
                           <v-text-field v-model="item.nfseAutorizacao.dataHora" label="Data/Hora Autorizacao" dense outlined readonly/>
                       </v-col>
                       <v-col cols="12" md="4" sm="6">
                           <v-text-field v-model="item.nfseAutorizacao.chaveAcesso" label="Chave de Acesso" dense outlined readonly/>
                       </v-col>
                       <v-col cols="12" md="4" sm="12">
                           <v-text-field v-model="item.nfseAutorizacao.urlVisualizacao" label="URL de Visualizacao" dense outlined readonly/>
                       </v-col>
                   </v-row>
               </v-form>
           </v-card-text>
       </v-card>

       <v-overlay :value="salvando">
           <v-progress-circular indeterminate size="64"></v-progress-circular>
       </v-overlay>

   </v-dialog>

</template>
<script>
import NFSeService from '@/core/services/fiscal/NFSeService';
import NFSe from '@/core/domain/fiscal/NFSe';
import DoadorService from '@/core/services/doacao/DoadorService';

export default {
   props:{
       item: {
           required: true
       },
       value: {}
   },
   watch: { 
       item: function() { 
           if ('formCadastroNFSe' in this.$refs)
               this.$refs.formCadastroNFSe.resetValidation();
       },
       value: function() {
           this.dialog = this.value;
       },
       searchDoador (val) {
            if (this.isDoadorLoading) return;
            if (!val) return;
            // if (val.length < 3 ) return;
            
            this.isDoadorLoading = true
            let doadorService = new DoadorService();
            doadorService.AutoComplete(val)
                .then(
                    res => {
                        this.doadores = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isDoadorLoading = false))
        },
       dialog: function() {
           if (!this.dialog) {
               this.$emit('fechou');
           }
       },
       "item.valor": function() {
            this.AtualizaValores();
       },
       "item.aliquotaIss": function() {
            this.AtualizaValores();
       },
       "item.retido": function() {
            this.AtualizaValores();
       }
   },
   data: () => ({
       service: new NFSeService(),
       valid: true,
       dialog: false,
       isDoadorLoading: false,
       isLoading: false,
       doadores: [],
       searchDoador: null,
       fieldRules: [
           v => !!v || 'Campo obrigatório'
       ],
       sessionApp: {},
       salvando: false
   }),
   methods: {
       save() {

           if (this.$refs.formCadastroNFSe.validate()) {

               this.salvando = true;

               let modelo = new NFSe(this.item);
               
               if (modelo.id == 0){
                  modelo.receitaId = undefined;
               }

               this.service.Salvar(modelo).then(
                   res => {
                       this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                       this.$emit('salvou');
                       this.close();
                   }, 
                   err =>  {
                       this.$swal('Aviso', err.response.data.title ? err.response.data.title : err.response.data, err.response.status == 400 ? 'warning' : 'error');
                   }
               ).finally(() => {
                   this.salvando = false;
               })
           }

       },
       close() {
           this.dialog = false;
       },
       AtualizaValores(){
        this.item.valorIss = (this.item.valor * (this.item.aliquotaIss / 100)).toFixed(2);
        this.item.valorRetido = this.item.retido ? this.item.valorIss : 0;
        this.item.valorLiquido = this.item.valor - this.item.valorRetido;
       }
   },
   beforeUpdate(){
       if (!this.dialog){
           this.$emit('fechou');
       }
   },
   mounted() {

   }
}
</script>
